import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { Paper, Box } from '@mui/material'

import { ApplicationState } from '@/state/root.models'
import { useSelector } from 'react-redux'
import {
  UiFeedbackTransactionsComponent,
  TransactionTableComponent,
  TransactionsFilters,
} from './components'

import { useTransactionsActions, useTransactionsFilters } from './hooks'
import { BonusType } from '@/enums'

const TransactionsModule = () => {
  const { getAllTransactions, setTransactionsFilters, cleanTransactions } =
    useTransactionsActions()

  const { filters } = useTransactionsFilters()

  const { brand } = useSelector(({ auth }: ApplicationState) => auth)

  const location = useLocation()

  const queryParams = new URLSearchParams(location.search)

  const walletId = queryParams.get('id')
  const walletType = queryParams.get('type')

  useEffect(() => {
    getAllTransactions({ ...filters, walletId, walletType })
    setTransactionsFilters({ ...filters, walletId, walletType })

    return () => {
      cleanTransactions()
      setTransactionsFilters({
        page: 1,
        limit: 25,
      })
    }
  }, [brand]) // eslint-disable-line

  return (
    <Box
      component={Paper}
      minHeight="calc(100vh - 168px)"
      display="flex"
      flexDirection="column"
      borderRadius={2}
    >
      {/* {filters.walletType !== BonusType.FREE_PLAY && ( */}
      <Box p={2}>
        <TransactionsFilters />
      </Box>
      {/* )} */}
      <TransactionTableComponent />
      <UiFeedbackTransactionsComponent />
    </Box>
  )
}

export default TransactionsModule
